import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { HTTPService } from "src/app/services/http.service";
import { SnackbarService } from "src/app/services/snackbar.service";
import { CronFormComponent } from "../cron-form/cron-form.component";
import { BehaviorSubject } from "rxjs";
import { FormServices } from "src/app/services/form.services";

@Component({
    selector: "wizard-configuracao",
    templateUrl: "./wizard-configuracao.component.html",
    styleUrls: ["./wizard-configuracao.component.scss"],
    standalone: false
})
export class WizardConfiguracaoComponent implements OnInit, AfterViewInit {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder,
    private http: HTTPService,
    private snackbar: SnackbarService,
    private fs:FormServices
  ) {}

  isLinear = true;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  cronComponent = CronFormComponent;
  @Input() insert: boolean = true;
  @Input()data;
  editing: boolean = false;
  btnName = "Editar";
  saveDisabled = true;
  saving: EventEmitter<boolean> = new EventEmitter();
  multiContext = false;
  @Output() onChange:BehaviorSubject<object> = new BehaviorSubject({});
  typeAmbiente:[
    {
      key:1,
      name:'Produção'
    },
    {
      key:2,
      name:'Homologação'
    }
  ]
  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      nome: ["", Validators.required],
      CODEMKTP: ["", Validators.required],
      CODECOMPANY: ["", Validators.required],
      IDTPI: ["", Validators.required],
      idconf: [""],
    });

    this.firstFormGroup.addControl("CODECOMPANY->NAME", new UntypedFormControl(null));

    this.firstFormGroup.addControl("CODEMKTP->NAME", new UntypedFormControl(null));

    this.firstFormGroup.addControl("IDTPI->NAME", new UntypedFormControl(null));

    this.secondFormGroup = this._formBuilder.group({
      schedule: ["", Validators.required],
      ativo: [{ value: "N", disabled: true }, Validators.required],
      ambiente: [{ value: "1", disabled: true }, Validators.required],
      diasret: ["1", Validators.required],
    });
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    if (this.data.evento != "editando") {
      this.insert = true;
    } else {
      this.insert = false;
    }

    if (!this.insert) {
      this.updateValues();
    }

    this.changeDetectorRef.detectChanges();
  }

  updateValues() {
    this.firstFormGroup.get("nome").setValue(this.data.row["NAME"]);
    this.firstFormGroup.get("idconf").setValue(this.data.row["IDCONF"]);

    this.firstFormGroup
    .get("CODECOMPANY")
    .patchValue(this.data.row["CODECOMPANY_CAB"]);

    this.firstFormGroup
      .get("CODECOMPANY->NAME")
      .patchValue(this.data.row["CODECOMPANY_NAME_CAB"]);
    
    this.firstFormGroup.get("CODEMKTP").patchValue(this.data.row["CODEMKTP"]);
    this.firstFormGroup
      .get("CODEMKTP->NAME")
      .patchValue(this.data.row["CODEMKTP_NAME"]);

    this.firstFormGroup.get("IDTPI").patchValue(this.data.row["IDTPI"]);

    this.firstFormGroup
      .get("IDTPI->NAME")
      .patchValue(this.data.row["IDTPI_NAME"]);
    
    this.secondFormGroup.get("ativo").setValue(this.data.row["ACTIVE"]);
    this.secondFormGroup.get("schedule").setValue(this.data.row["SCHEDULE"]);
    this.secondFormGroup.get("ambiente").setValue(this.data.row["ENVIRONMENT"]);
    this.secondFormGroup.get("diasret").setValue(this.data.row["RETETIONDAYS"]);

    if ( this.data.row['MULTI']=='S'){
      this.secondFormGroup.get('schedule').removeValidators(Validators.required);
    }

    this.controleAction();
  }

  clickEdit() {
    this.editing = !this.editing;

    if (!this.editing) {
      this.btnName = "Editar";
    } else {
      this.btnName = "Cancelar";
    }

    this.controleAction();
  }

  controleAction() {
    if (this.editing) {
      this.saveDisabled = false;
      Object.keys(this.firstFormGroup.controls).forEach((key) => {
        this.firstFormGroup.get(key).enable();
      });

      Object.keys(this.secondFormGroup.controls).forEach((key) => {
        this.secondFormGroup.get(key).enable();
      });
    } else {
      this.saveDisabled = true;
      Object.keys(this.firstFormGroup.controls).forEach((key) => {
        this.firstFormGroup.get(key).disable();
      });

      Object.keys(this.secondFormGroup.controls).forEach((key) => {
        this.secondFormGroup.get(key).disable();
      });
    }
  }

  updateCurrentRow() {
      this.data.row["NAME"] = this.firstFormGroup.get("nome").value;
      this.data.row["CODECOMPANY"] = this.firstFormGroup.get("CODECOMPANY").value;
      this.data.row["FK_MKTPCFG_MKTPCOMPANIES->NAME"] = this.firstFormGroup.get("CODECOMPANY->NAME").value;
      this.data.row["CODEMKTP"] = this.firstFormGroup.get("CODEMKTP->NAME").value;
      this.data.row["FK_MKTPCFG_MKTPLACES->NAME"] = this.firstFormGroup.get("CODEMKTP->NAME").value;
      this.data.row["IDTPI"] = this.firstFormGroup.get("IDTPI").value;
      this.data.row["FK_MKTPCFG_MKTPTPI->NAME"] = this.firstFormGroup.get("IDTPI->NAME").value;
      this.data.row["ACTIVE"] = this.secondFormGroup.get("ativo").value;
      this.data.row["SCHEDULE"] = this.secondFormGroup.get("schedule").value;
      this.data.row["RETETIONDAYS"] = this.secondFormGroup.get("diasret").value;
      this.data.row["ENVIRONMENT"] = this.secondFormGroup.get("ambiente").value;
  }

  itemSelect(event) {}

  formSubmitted(result) {
    this.secondFormGroup.get("schedule").setValue(result);
  }

  onToggleChange(){
      if ( this.multiContext ){
        this.firstFormGroup.get("CODECOMPANY").setValue("0");
        this.firstFormGroup.get("CODECOMPANY->NAME").setValue("-");
        this.firstFormGroup.get("CODECOMPANY").clearValidators();
      }else{
        this.firstFormGroup.get("CODECOMPANY").setValue(null);
        this.firstFormGroup.get("CODECOMPANY->NAME").setValue(null);
        this.firstFormGroup.get("CODECOMPANY").addValidators(Validators.required);
      }
  }

  salvar() {
    if (this.secondFormGroup.invalid || this.firstFormGroup.invalid) {
      this.secondFormGroup.markAllAsTouched();
      this.firstFormGroup.markAllAsTouched();
      if ( this.secondFormGroup.invalid){
        this.snackbar.showError(this.fs.getFormErrors(this.secondFormGroup,null));
      }
      if( this.firstFormGroup.invalid){
        this.snackbar.showError(this.fs.getFormErrors(this.firstFormGroup,null));
      }
      
      return;
    }


    let ob = {
      entityName: "Mktpcfg",
      CODEMKTP: this.firstFormGroup.get("CODEMKTP").value,
      CODECOMPANY: this.firstFormGroup.get("CODECOMPANY").value,
      IDTPI: this.firstFormGroup.get("IDTPI").value,
      ACTIVE: this.secondFormGroup.get("ativo").value,
      SCHEDULE: this.secondFormGroup.get("schedule").value,
      RETETIONDAYS: this.secondFormGroup.get("diasret").value,
      ENVIRONMENT: this.secondFormGroup.get("ambiente").value,
      NAME: this.firstFormGroup.get("nome").value,
      PREFERENCES:'use.experimental.formula.conf;experimental.header.split;use.new.recursivexml;use.experimental.formula.with.doretry;mktplace.remove.start.end.quotes.on.split;mktp.use.new.regex.function.discovery.idconf',
      TYPETEC: "1",
      RECMODIFYBY: null,
      RECMODIFYON: null,
    };

    if (!this.insert) {
      ob["IDCONF"] = this.firstFormGroup.get("idconf").value;
    }

    this.http.post(ob, "JsonBrokerServices/save", false, true, true).subscribe(
      (x) => {
        this.snackbar.showSuccess("Registro Inserido/Alterado com sucesso.");
        
        if (!this.insert) {
          this.clickEdit();
          this.controleAction();
          this.updateCurrentRow();
        } else {
          this.firstFormGroup.get("idconf").setValue(x["IDCONF"]);
          this.saving.next(true);
          this.insert = false;
        }
      },
      (error) => {
        throw error;
      }
    );
  }

  exit(){
      
  }
}
